import { render, staticRenderFns } from "./DestinationForm.vue?vue&type=template&id=12c71afc"
import script from "./DestinationForm.vue?vue&type=script&lang=js"
export * from "./DestinationForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports